<template>
  <div class="recruit">
    <SectionContainer>
      <div v-if="!content && !flag.isLoading">無効なURLです。</div>
      <SectionFrame
        v-if="content"
        :marginTop="112">
        <div class="position-relative">
          <div v-if="content.medias.length" :class="[s.img, s.bg]" :style="`background-image: url('${$mediaUrl(content.medias[0].url)}')`"/>
          <div v-if="content.medias.length" :class="s.img" :style="`background-image: url('${$mediaUrl(content.medias[0].url)}')`"/>
        </div>
        <div :class="s.caption" v-if="content?.medias[0]?.caption">{{ content.medias[0].caption }}</div>
        <spacer :y="8"/>
        <div :class="s.name">{{ content.title }}</div>
        <div :class="s.organization">{{ content.organization_name }}</div>
        <div :class="s.date" v-if="content.publish_date">掲載日：{{ formatPublishDate(content.publish_date) }}</div>
        <div v-if="content.tags?.length" :class="s.tags">
          <FlexList
            :spaceX="12"
            :spaceY="12"
            :wrap="true">
            <li v-for="tag in content.tags" :key="tag.id">
              <tag-btn
                :size="'sm'"
                :type="'category'">{{ tag.label }}</tag-btn>
            </li>
          </FlexList>
        </div>
        <div v-html="content.content" :class="s.content"/>
        <spacer :y="10"/>
      </SectionFrame>
    </SectionContainer>
    <SectionContainer>
      <SectionFrame
        :title="'ほかの求人'"
        :titleBottomMargin="48"
        v-if="otherRecruits.length">
        <FlexList
          :spaceX="40"
          :spaceY="32"
          :align="'center'"
          :count="2"
          :smCount="1"
          :wrap="true">
          <li v-for="item of otherRecruits" :key="item.id">
            <router-link :to="`/hataraku/${item.open_id}/`" :class="s.itemLink">
              <ContentCard
                :img="item.medias[0]?.url"
                :imgRatio="70"
                :smImgRatio="70"
                :date="item.organization_name"
                :name="item.title"
                :content="stripHtml(item.content)"
                :contentBg="'wht'"
                :radius="28"
                :hasShadow="true">
                <spacer :y="1"/>
                <FlexList
                  :spaceX="12"
                  :spaceY="12"
                  :wrap="true">
                  <li v-for="tag in item.tags" :key="tag.id">
                    <tag-btn
                      :size="'sm'"
                      :type="'category'">{{ tag.label }}</tag-btn>
                  </li>
                </FlexList>
              </ContentCard>
            </router-link>
          </li>
        </FlexList>
        <Spacer :y="7"/>
        <FlexList :align="'center'">
          <basic-btn
            :tag="'a'"
            :link="'/hataraku/'">もっと見る</basic-btn>
        </FlexList>
      </SectionFrame>
    </SectionContainer>

    <spacer :y="12"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  SectionContainer,
  SectionFrame,
  Spacer,
  FlexList,
  ContentCard,
  TagBtn,
  BasicBtn,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'recruit-detail',
  mixins: [cf],
  components: {
    SectionContainer,
    SectionFrame,
    Spacer,
    FlexList,
    ContentCard,
    TagBtn,
    BasicBtn,
  },
  data() {
    return {
      flag: {
        isLoading: true,
      },
      content: null,
      otherRecruits: [],
    };
  },
  computed: {
    ...mapState(['helper']),
    openId() {
      return this.$route.params.open_id;
    },
  },
  created() {
    this.get();
    this.getOther();
  },
  watch: {
    $route() {
      this.get();
      this.getOther();
    },
  },
  methods: {
    stripHtml(html) {
      if (!html) return '';
      return String(html).replace(/<[^>]*>/g, '').slice(0, 120);
    },
    formatPublishDate(date) {
      if (!date) return '';
      return String(date).slice(0, 10);
    },
    get() {
      this.flag.isLoading = true;
      this.content = null;
      const params = {
        open_id: this.openId,
        flags: [1],
        isBeforeToday: 1,
      };

      this.axios({
        method: 'GET',
        url: '/v1/recruit/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.content = res.detail;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.isLoading = false;
        });
    },
    getOther() {
      const params = {
        flags: [1],
        isBeforeToday: 1,
        excludeOpenId: this.openId,
        orderBy: 'publish_date',
        order: 'desc',
        limit: 2,
      };

      this.axios({
        method: 'GET',
        url: '/v1/recruit/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.otherRecruits = res.recruits.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.img {
  width: 100%;
  padding-top: 66%;
  background-size: contain;
  background-color: rgba(#FFFFFF, 0.3);
  backdrop-filter: blur(12px);
  background-repeat: no-repeat;
  border-radius: 28px;
  background-position: center;

  &.bg {
    padding-top: 66%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.caption {
  font-size: 14px;
  color: var(--label-secondary);
  text-align: right;
  margin-top: 12px;
}

.name {
  font-weight: 700;
  font-size: 24px;
}

.organization {
  font-size: 14px;
  margin-top: 4px;
}

.date {
  font-size: 12px;
  margin-top: 8px;
  color: var(--label-secondary);
}

.tags {
  margin-top: 16px;
}

.content {
  margin-top: 24px;
}

.itemLink {
  display: block;
  height: 100%;
  > * {
    height: 100%;
  }
}
</style>
